<script setup>
import { OhVueIcon } from "oh-vue-icons";
import { computed } from 'vue';
import { store } from '../store.js';
import FormButtons from "./forms/FormButtons.ce.vue";
import FormFields from "./forms/FormFields.ce.vue";

const props = defineProps({
    locale: {
        type: String,
        default: "nl_NL"
    },
});

store.locale = computed(() => props.locale);
store.fetch.addTranslations(props.locale)
</script>

<template>
    <h1 class="flex items-center text-xl mb-2">
        <OhVueIcon name="gi-receive-money" fill="wageindicator-orange" class="mr-2" width="48" scale="2" />
        {{ store.translations.survey_title }}
    </h1>

    <FormFields :survey="store.survey.full" />

    <div class="mt-8">
        <FormButtons :survey="store.survey.full" />
    </div>
</template>


<style>
@import url("../style.css");

:host {
    /* Reset all CSS properties */
    all: initial;
    color: initial;
    font-family: Open Sans, sans-serif;
}
</style>
